import { FC, PropsWithChildren } from 'react';
import styles from './index.module.scss';

interface IProps extends PropsWithChildren {
  title: string;
}

const FileUploaderTile: FC<IProps> = (props: IProps): JSX.Element => {
  const { title, children } = props;

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      {children}
    </div>
  );
};

export default FileUploaderTile;
